// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LinkItem__container-d5b20e {
  display: flex;
  padding: 12px var(--padding);
}

.LinkItem__preview-image-c613a0 {
  width: 40px;
  height: 40px;
  background-color: var(--base-17);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.LinkItem__preview-image-c613a0 a {
  height: 100%;
  width: 100%;
}

.LinkItem__icon-dd3678 {
  fill: var(--brand-primary-40);
}

.LinkItem__image-d9f659 {
  object-fit: cover;
  width: inherit;
  height: inherit;
  box-sizing: border-box;
}

.LinkItem__info-bf432f {
  margin-inline-start: 16px;
}

.LinkItem__title-afa274 {
  font: var(--font-body-6);
  letter-spacing: var(--font-spacing-body-6);
  color: var(--base-110);
  word-break: break-all;
}

.LinkItem__description-dcd42e {
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
  color: var(--base-80);
  margin-top: 2px;
  word-break: break-all;
}

.LinkItem__list-cb9308 {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.LinkItem__list-item-f8d8f7 {
  margin-top: 2px;
  word-break: break-all;
}

.LinkItem__list-item-f8d8f7 a {
  text-decoration: none;
}

.LinkItem__list-item-f8d8f7 a:hover,
.LinkItem__list-item-f8d8f7 a:active,
.LinkItem__list-item-f8d8f7 a:focus-visible {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/main/SharedData/Links/LinkItem/LinkItem.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,4BAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,gCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,qBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,qBAAA;EACA,eAAA;EACA,qBAAA;AACF;;AAEA;EACE,qBAAA;EACA,SAAA;EACA,UAAA;AACF;;AAEA;EACE,eAAA;EACA,qBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;;;EAGE,0BAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  padding: 12px var(--padding);\n}\n\n.preview-image {\n  width: 40px;\n  height: 40px;\n  background-color: var(--base-17);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.preview-image a {\n  height: 100%;\n  width: 100%;\n}\n\n.icon {\n  fill: var(--brand-primary-40);\n}\n\n.image {\n  object-fit: cover;\n  width: inherit;\n  height: inherit;\n  box-sizing: border-box;\n}\n\n.info {\n  margin-inline-start: 16px;\n}\n\n.title {\n  font: var(--font-body-6);\n  letter-spacing: var(--font-spacing-body-6);\n  color: var(--base-110);\n  word-break: break-all;\n}\n\n.description {\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n  color: var(--base-80);\n  margin-top: 2px;\n  word-break: break-all;\n}\n\n.list {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n\n.list-item {\n  margin-top: 2px;\n  word-break: break-all;\n}\n\n.list-item a {\n  text-decoration: none;\n}\n\n.list-item a:hover,\n.list-item a:active,\n.list-item a:focus-visible {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `LinkItem__container-d5b20e`,
	"preview-image": `LinkItem__preview-image-c613a0`,
	"previewImage": `LinkItem__preview-image-c613a0`,
	"icon": `LinkItem__icon-dd3678`,
	"image": `LinkItem__image-d9f659`,
	"info": `LinkItem__info-bf432f`,
	"title": `LinkItem__title-afa274`,
	"description": `LinkItem__description-dcd42e`,
	"list": `LinkItem__list-cb9308`,
	"list-item": `LinkItem__list-item-f8d8f7`,
	"listItem": `LinkItem__list-item-f8d8f7`
};
module.exports = ___CSS_LOADER_EXPORT___;
